import { PatientPortalSystemOptions } from 'types/patient-portal-system.types';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { EVENT_NAME } from '@leagueplatform/analytics';
import { ANALYTICS_SCREEN_NAMES } from 'common/constants';
import { useOnboardingAnalytics } from 'hooks/use-onboarding-analytics/use-onboarding-analytics.hook';
import { useEffect } from 'react';
import { MyHealthCompleteStep } from './my-health-complete-step.component';
import { AmplarCompleteStep } from './amplar-complete-step.component';

export interface CompleteStepProps {
  onComplete: () => void;
}

export const CompleteStep = ({ onComplete }: CompleteStepProps) => {
  const { systemId } = usePatientPortalContext();
  const SystemCompleteStepMap: Record<
    PatientPortalSystemOptions,
    React.FC<CompleteStepProps>
  > = {
    myhealth: MyHealthCompleteStep,
    amplar: AmplarCompleteStep,
  };

  const trackEvent = useOnboardingAnalytics(
    ANALYTICS_SCREEN_NAMES.ACCOUNT_SETUP_COMPLETE,
  );

  useEffect(() => {
    trackEvent(EVENT_NAME.SCREEN_LOADED, {
      onboarding_complete: true,
    });
  }, [trackEvent]);

  const SystemCompleteStep = SystemCompleteStepMap[systemId];

  return <SystemCompleteStep onComplete={onComplete} />;
};
